import { call, put, takeEvery } from "redux-saga/effects";

import {
    GET_SPLUNK_REFRESH,
    GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE,
    GET_ALL_ORG_SPLUNK_RESOURCE_TYPES,
    GET_SPLUNK_ALL_RESOURCE_COUNT,
    GET_USER_RESCAN_STATUS_SPLUNK,
    POST_SPLUNK_SERVICE_MAPPING,
    POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING,
    GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE,
    GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT,
    GET_SPLUNK_ALERTS,
    GET_SPLUNK_DEFAULT_THRESHOLD,
    GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_SPLUNK_RESOURCE_BY_ID,
    GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID,
    GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
    GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
    GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD,
    GET_SPLUNK_RESOURCES,
    PUT_SPLUNK_THRESHOLD,
    POST_SPLUNK_DISABLE_THRESHOLD_ALERTS,
    POST_SPLUNK_ENABLE_THRESHOLD_ALERTS,
    POST_SPLUNK_DISABLE_ALERTS,
    POST_SPLUNK_ENABLE_ALERTS,
    POST_SPLUNK_CREATE_RESOURCE_ALERTS,
    PUT_SPLUNK_ALERTS
} from "./actionTypes";

import {
    getSplunkRefreshFail,
    getSplunkRefreshSuccess,
    getSplunkAllResourceAlertsPageFail,
    getSplunkAllResourceAlertsPageSuccess,
    getAllOrgSplunkResourceTypesFail,
    getAllOrgSplunkResourceTypesSuccess,
    getSplunkAllResourceCountFail,
    getSplunkAllResourceCountSuccess,
    getSplunkRefreshScanStatusFail,
    getSplunkRefreshScanStatusSuccess,
    postSplunkServiceMappingFail,
    postSplunkServiceMappingSuccess,
    postSplunkResourceOpsgenieTeamMappingFail,
    postSplunkResourceOpsgenieTeamMappingSuccess,
    postSplunkResourcePagerDutyServiceMappingFail,
    postSplunkResourcePagerDutyServiceMappingSuccess,
    getSpunkAllServiceDependencyResourceAlertsPageFail,
    getSpunkAllServiceDependencyResourceAlertsPageSuccess,
    getSplunkAllServiceDependencyResourceCountFail,
    getSplunkAllServiceDependencyResourceCountSuccess,
    getSplunkAlertsFail,
    getSplunkAlertsSuccess,
    getSplunkDefaultThresholdFail,
    getSplunkDefaultThresholdSuccess,
    getSplunkMissingAlertsByResourceIdFail,
    getSplunkMissingAlertsByResourceIdSuccess,
    getSplunkResourceByIdFail,
    getSplunkResourceByIdSuccess,
    getSplunkDefaultThresholdByResourceIdFail,
    getSplunkDefaultThresholdByResourceIdSuccess,
    getSplunkDynamicAlertsDeployedByResourceIdFail,
    getSplunkDynamicAlertsDeployedByResourceIdSuccess,
    getSplunkMissingDynamicAlertsByResourceIdFail,
    getSplunkMissingDynamicAlertsByResourceIdSuccess,
    getSplunkDynamicDefaultThresholdFail,
    getSplunkDynamicDefaultThresholdSuccess,
    getSplunkResourcesFail,
    getSplunkResourcesSuccess,
    putSplunkThresholdFail,
    putSplunkThresholdSuccess,
    postSplunkDisableThresholdAlertsFail,
    postSplunkDisableThresholdAlertsSuccess,
    postSplunkEnableThresholdAlertsFail,
    postSplunkEnableThresholdAlertsSuccess,
    postSplunkDisableAlertsFail,
    postSplunkDisableAlertsSuccess,
    postSplunkEnableAlertsFail,
    postSplunkEnableAlertsSuccess,
    postSplunkCreateResourceAlertsFail,
    postSplunkCreateResourceAlertsSuccess,
    putSplunkAlertsFail,
    putSplunkAlertsSuccess
} from "./actions";

import {
    getSplunkRefreshResourcesUrl,
    getSplunkAllResourceAlertsPageUrl,
    getAllOrgSplunkResourceTypesUrl,
    getSplunkAllResourceCountUrl,
    getRescanStatusSplunkUrl,
    postSplunkServiceMappingUrl,
    postSplunkResourceOpsgenieTeamMapping,
    postSplunkResourcePagerdutyServiceMappingCall,
    getSplunkAllServiceDependencyResourceAlertsPageUrl,
    getSplunkAllServiceDependencyResourceCountUrl,
    getSplunkAlertsUrl,
    getSplunkDefaultThresholdUrl,
    getSplunkMissingAlertsByResourceIDUrl,
    getSplunkResourceByIDUrl,
    getDefaultThresholdsSplunkResourceByIDUrl,
    getSplunkDynamicAlertsDeployedByResourceId,
    getSplunkMissingDynamicAlertsByResourceId,
    getSplunkResourcesUrl,
    postSplunkUpdateThresholdUrl,
    postSplunkToggleThresholdAlertUrl,
    postSplunkDisableAlertUrl,
    postSplunkEnableAlertUrl,
    postSplunkCreateAlertsUrl,
    putSplunkUpdateAlertUrl
} from "../../helpers/fakebackend_helper";

import {showNotification} from "../../components/Common/notification";


function* onGetSplunkRefresh() {
    try {
        const response = yield call(getSplunkRefreshResourcesUrl());
        yield put(getSplunkRefreshSuccess(response));
        if (response.scan_completed === false) {
            showNotification("error", response.message);
        }
    } catch (error) {
        yield put(getSplunkRefreshFail(error));
    }
}


function* onGetSplunkAllResourceAlertsPage({payload: {page_filters}}) {
    try {
        const response = yield call(getSplunkAllResourceAlertsPageUrl, page_filters);
        yield put(getSplunkAllResourceAlertsPageSuccess(response));
    } catch (error) {
        yield put(getSplunkAllResourceAlertsPageFail(error));
    }
}


function* onGetAllOrgSplunkResourceTypes() {
    try {
        const response = yield call(getAllOrgSplunkResourceTypesUrl);
        yield put(getAllOrgSplunkResourceTypesSuccess(response));
    } catch (error) {
        yield put(getAllOrgSplunkResourceTypesFail(error));
    }

}

function* onGetSplunkAllResourceCount({payload: {page_filters}}) {
    try {
        const response = yield call(getSplunkAllResourceCountUrl, page_filters);
        yield put(getSplunkAllResourceCountSuccess(response));
    } catch (error) {
        yield put(getSplunkAllResourceCountFail(error));
    }
}

function* onGetSplunkRefreshScanStatus() {
    try {
        const response = yield call(getRescanStatusSplunkUrl);
        yield put(getSplunkRefreshScanStatusSuccess(response));
    } catch (error) {
        yield put(getSplunkRefreshScanStatusFail(error));
    }
}

function* onPostSplunkServiceMapping({payload: {service_mapping}}) {
    try {
        const response = yield call(postSplunkServiceMappingUrl, service_mapping);
        yield put(postSplunkServiceMappingSuccess(response));
    } catch (error) {
        yield put(postSplunkServiceMappingFail(error));
    }
}

function* onPostSplunkResourceOpsgenieTeamMapping({payload: {splunk_resource_team_mapping}}) {
    try {
        const response = yield call(postSplunkResourceOpsgenieTeamMapping, splunk_resource_team_mapping);
        yield put(postSplunkResourceOpsgenieTeamMappingSuccess(response));
    } catch (error) {
        yield put(postSplunkResourceOpsgenieTeamMappingFail(error));
    }
}

function* onPostSplunkResourcePagerDutyServiceMapping({payload: {splunk_resource_pagerduty_service_mapping}}) {
    try {
        const response = yield call(postSplunkResourcePagerdutyServiceMappingCall, splunk_resource_pagerduty_service_mapping);
        yield put(postSplunkResourcePagerDutyServiceMappingSuccess(response));
    } catch (error) {
        yield put(postSplunkResourcePagerDutyServiceMappingFail(error));
    }
}

function* onGetSplunkAllServiceDependencyResourceAlertsPage({payload: {page_filters}}) {
    try {
        const response = yield call(getSplunkAllServiceDependencyResourceAlertsPageUrl, page_filters);
        yield put(getSpunkAllServiceDependencyResourceAlertsPageSuccess(response));
    } catch (error) {
        yield put(getSpunkAllServiceDependencyResourceAlertsPageFail(error));
    }
}

function* onGetSplunkAllServiceDependencyResourceCount({payload: {page_filters}}) {
    try {
        const response = yield call(getSplunkAllServiceDependencyResourceCountUrl, page_filters);
        yield put(getSplunkAllServiceDependencyResourceCountSuccess(response));
    } catch (error) {
        yield put(getSplunkAllServiceDependencyResourceCountFail(error));
    }
}

function* onGetSplunkAlerts(monitored_resource_id) {
    try {
        const response = yield call(getSplunkAlertsUrl, monitored_resource_id.payload);
        let final_response = {}
        final_response[monitored_resource_id.payload] = response;
        yield put(getSplunkAlertsSuccess(final_response));
    } catch (error) {
        yield put(getSplunkAlertsFail(error));
    }
}

function* onGetSplunkDefaultThreshold(threshold_type) {
    try {
        const response = yield call(getSplunkDefaultThresholdUrl, threshold_type.payload);
        yield put(getSplunkDefaultThresholdSuccess(response));
    } catch (error) {
        yield put(getSplunkDefaultThresholdFail(error));
    }
}

function* onGetSplunkMissingAlertsByResourceId(monitored_resource_id) {
    try {
        const response = yield call(getSplunkMissingAlertsByResourceIDUrl, monitored_resource_id.payload);
        yield put(getSplunkMissingAlertsByResourceIdSuccess(response));
    } catch (error) {
        yield put(getSplunkMissingAlertsByResourceIdFail(error));
    }
}

function* onGetSplunkResourceById(monitored_resource_id) {
    try {
        const response = yield call(getSplunkResourceByIDUrl, monitored_resource_id.payload);
        yield put(getSplunkResourceByIdSuccess(response));
    } catch (error) {
        yield put(getSplunkResourceByIdFail(error));
    }
}

function* onGetSplunkDefaultThresholdByResourceId(monitored_resource_id) {
    try {
        const response = yield call(getDefaultThresholdsSplunkResourceByIDUrl, monitored_resource_id.payload);
        yield put(getSplunkDefaultThresholdByResourceIdSuccess(response));
    } catch (error) {
        yield put(getSplunkDefaultThresholdByResourceIdFail(error));
    }
}

function* onGetSplunkDynamicAlertsDeployedByResourceId(monitored_resource_id) {
    try {
        const response = yield call(getSplunkDynamicAlertsDeployedByResourceId, { monitored_resource_id: monitored_resource_id.payload });
        yield put(getSplunkDynamicAlertsDeployedByResourceIdSuccess(response));
    } catch (error) {
        yield put(getSplunkDynamicAlertsDeployedByResourceIdFail(error));
    }
}

function* onGetSplunkMissingDynamicAlertsByResourceId(monitored_resource_id) {
    try {
        const response = yield call(getSplunkMissingDynamicAlertsByResourceId, { monitored_resource_id: monitored_resource_id.payload });
        yield put(getSplunkMissingDynamicAlertsByResourceIdSuccess(response));
    } catch (error) {
        yield put(getSplunkMissingDynamicAlertsByResourceIdFail(error));
    }
}

function* onGetSplunkDynamicDefaultThreshold(threshold_type) {
    try {
        const response = yield call(getSplunkDefaultThresholdUrl, threshold_type.payload);
        yield put(getSplunkDynamicDefaultThresholdSuccess(response));
    } catch (error) {
        yield put(getSplunkDynamicDefaultThresholdFail(error));
    }
}

function* onGetSplunkResources() {
    try {
        const response = yield call(getSplunkResourcesUrl);
        yield put(getSplunkResourcesSuccess(response));
    } catch (error) {
        yield put(getSplunkResourcesFail(error));
    }
}

function* onPutSplunkThreshold({payload: {thresholds}}) {
    try {
        const response = yield call(postSplunkUpdateThresholdUrl, thresholds);
        yield put(putSplunkThresholdSuccess(response));
    } catch (error) {
        yield put(putSplunkThresholdFail(error));
    }
}

function* onPostSplunkDisableThresholdAlerts({payload: {alerts}}) {
    const response = yield call(postSplunkToggleThresholdAlertUrl, alerts);
    window.location.reload()
}

function* onPostSplunkEnableThresholdAlerts({payload: {alerts}}) {
    const response = yield call(postSplunkToggleThresholdAlertUrl, alerts);
    window.location.reload()
}

function* onPostSplunkDisableAlerts({payload: {alerts}}) {
    try {
        const response = yield call(postSplunkDisableAlertUrl, alerts);
        yield put(postSplunkDisableAlertsSuccess(response));
        window.location.reload()
    } catch(error) {
        yield put(postSplunkDisableAlertsFail(error.message));
    }
}

function* onPostSplunkEnableAlerts({payload: {alerts}}) {
    try {
        const response = yield call(postSplunkEnableAlertUrl, alerts);
        yield put(postSplunkEnableAlertsSuccess(response));
        window.location.reload()
    } catch(error) {
        yield put(postSplunkEnableAlertsFail(error.message));
    }
}

function* onPostSplunkCreateResourceAlerts({payload: {alerts}}) {
    try {
        const currentUrl = window.location.href;
        const response = yield call(postSplunkCreateAlertsUrl, alerts);
        if (response){
            window.location.reload();
            window.location.href = currentUrl;
        }
    } catch (error) {
        if (error.response.data.message === "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* onPutSplunkAlerts({payload: {alerts}}) {
    try {
        const response = yield call(putSplunkUpdateAlertUrl, alerts);
        if (response){
            window.location.reload()
        }
    } catch (error) {
        if (error.response.data.message === "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* splunkSaga() {
    yield takeEvery(GET_SPLUNK_REFRESH, onGetSplunkRefresh);
    yield takeEvery(GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE, onGetSplunkAllResourceAlertsPage)
    yield takeEvery(GET_ALL_ORG_SPLUNK_RESOURCE_TYPES, onGetAllOrgSplunkResourceTypes)
    yield takeEvery(GET_SPLUNK_ALL_RESOURCE_COUNT, onGetSplunkAllResourceCount)
    yield takeEvery(GET_USER_RESCAN_STATUS_SPLUNK, onGetSplunkRefreshScanStatus)
    yield takeEvery(POST_SPLUNK_SERVICE_MAPPING, onPostSplunkServiceMapping)
    yield takeEvery(POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostSplunkResourceOpsgenieTeamMapping)
    yield takeEvery(POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING, onPostSplunkResourcePagerDutyServiceMapping)
    yield takeEvery(GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE, onGetSplunkAllServiceDependencyResourceAlertsPage)
    yield takeEvery(GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT, onGetSplunkAllServiceDependencyResourceCount)
    yield takeEvery(GET_SPLUNK_ALERTS, onGetSplunkAlerts)
    yield takeEvery(GET_SPLUNK_DEFAULT_THRESHOLD, onGetSplunkDefaultThreshold)
    yield takeEvery(GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID, onGetSplunkMissingAlertsByResourceId)
    yield takeEvery(GET_SPLUNK_RESOURCE_BY_ID, onGetSplunkResourceById)
    yield takeEvery(GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID, onGetSplunkDefaultThresholdByResourceId)
    yield takeEvery(GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID, onGetSplunkDynamicAlertsDeployedByResourceId)
    yield takeEvery(GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID, onGetSplunkMissingDynamicAlertsByResourceId)
    yield takeEvery(GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD, onGetSplunkDynamicDefaultThreshold)
    yield takeEvery(GET_SPLUNK_RESOURCES, onGetSplunkResources)
    yield takeEvery(PUT_SPLUNK_THRESHOLD, onPutSplunkThreshold)
    yield takeEvery(POST_SPLUNK_DISABLE_THRESHOLD_ALERTS, onPostSplunkDisableThresholdAlerts)
    yield takeEvery(POST_SPLUNK_ENABLE_THRESHOLD_ALERTS, onPostSplunkEnableThresholdAlerts)
    yield takeEvery(POST_SPLUNK_DISABLE_ALERTS, onPostSplunkDisableAlerts)
    yield takeEvery(POST_SPLUNK_ENABLE_ALERTS, onPostSplunkEnableAlerts)
    yield takeEvery(POST_SPLUNK_CREATE_RESOURCE_ALERTS, onPostSplunkCreateResourceAlerts)
    yield takeEvery(PUT_SPLUNK_ALERTS, onPutSplunkAlerts)
}

export default splunkSaga;